import {
  fetchClient
} from "./chunk-K342ITN7.mjs";
import {
  __async
} from "./chunk-DFMI36TU.mjs";

// src/core/shop/listing.ts
import { getLocaleOnly } from "@wbk/utils";
import { Exception } from "@wbk/logger";
var SHOP_BASE_URL = "https://webook.com/shop";
var getShopProducts = (_0) => __async(void 0, [_0], function* ({ lang, params, isHomePage }) {
  try {
    const locale = getLocaleOnly(lang);
    const query = new URLSearchParams(params);
    const data = yield fetchClient({
      baseUrl: SHOP_BASE_URL,
      url: `/${locale === "en" ? "en/" : ""}${isHomePage ? `wp-json/webook-home-products/v1/products?lang=${lang}` : `wp-json/wp/v2/product?${query}`}`,
      includeAuth: false,
      includeToken: false
    });
    return data.sort((a, b) => a.title.rendered.localeCompare(b.title.rendered));
  } catch (error) {
    throw new Exception({
      error,
      name: "getShopProductsException"
    });
  }
});

export {
  getShopProducts
};
//# sourceMappingURL=chunk-IZ43CSAA.mjs.map